import { S25Util } from "../../../util/s25-util";

export function isSameCalendarDay(firstDate: Date, secondDate: Date): boolean {
    return S25Util.date.getDate(firstDate).getTime() === S25Util.date.getDate(secondDate).getTime();
}

export function alignEndDayToStart(startDate: Date, endDate: Date): Date {
    const alignedEnd = S25Util.date.clone(endDate);
    S25Util.date.syncDateToDate(alignedEnd, startDate);
    return alignedEnd;
}

export function alignStartDayToEnd(startDate: Date, endDate: Date): Date {
    const alignedStart = S25Util.date.clone(startDate);
    S25Util.date.syncDateToDate(alignedStart, endDate);
    return alignedStart;
}

export function applySameDayCheckFix(startDate: Date, endDate: Date): Date {
    let alignedEnd = alignEndDayToStart(startDate, endDate);
    if (alignedEnd <= startDate) {
        alignedEnd = S25Util.date.addHours(S25Util.date.clone(startDate), 1);
        if (!isSameCalendarDay(startDate, alignedEnd)) {
            alignedEnd = S25Util.date.clone(startDate);
            alignedEnd.setHours(23, 59, 0, 0);
        }
    }
    return alignedEnd;
}
